// src/app/services/analytics.service.ts
import { Injectable, inject, PLATFORM_ID, isDevMode } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environment';


declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);

  init(): void {   

    if (isDevMode() || !isPlatformBrowser(this.platformId) || !environment.gaMeasurementId) {
      return;
    }

    this.injectGtagScripts();
    this.trackPageViews();
  }

  private injectGtagScripts(): void {
    const id = environment.gaMeasurementId;

    // 1. Inject the Google Analytics external script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);

    // 2. Inject the inline initialization script
    const inlineScript = document.createElement('script');
    inlineScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${id}', { send_page_view: false });
    `;
    document.head.appendChild(inlineScript);
  }

  private trackPageViews(): void {
    // Track SPA route changes using Angular Router events
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (typeof gtag === 'function') {
          gtag('config', environment.gaMeasurementId, {
            page_path: event.urlAfterRedirects,
            page_location: window.location.href
          });
        }
      });
  }

  /**
   * Track custom user events (e.g., button clicks, form submits)
   */
  logEvent(eventName: string, params: Record<string, any> = {}): void {
    if (isPlatformBrowser(this.platformId) && typeof gtag === 'function') {
      gtag('event', eventName, params);
    }
  }
}
/*
(Optional) Logging Custom Events
this.analytics.logEvent('purchase_completed', {
  value: 49.99,
  currency: 'USD'
});
*/